import { personMapping } from "utils/mapping/person"
import educationMapping from "utils/mapping/education"
import achievementMapping from "utils/mapping/achievement"
import awardMapping from "utils/mapping/award"
import _ from "lodash"

const SOURCE_URI = process.env.REACT_APP_PERSON_ENDPOINT
const CV_URI = process.env.REACT_APP_PERSON_CV
const X_API_KEY = process.env.REACT_APP_X_API_KEY
const X_DREAM_FACTORY_API_KEY = process.env.REACT_APP_X_DREAM_FACTORY_API_KEY

async function getPersonByUniStaffID(id) {
  const data = await getPerson(id)
  const returnData = {
    ...data,
    result: data.result.length > 0 ? data.result[0] : personMapping()
  }

  return returnData
}

async function getPerson(keyword, deptId) {
  let result = [], itemsCount = 0, status = 0, error = null
  const uri = SOURCE_URI + "/person_search"

  await fetch(uri, {
    method: "POST",
    headers: {
      "Content-type": "application/json",      
      "x-api-key": X_API_KEY
    },
    body: JSON.stringify({
      searchword: keyword,
      dept: deptId
    })
  })
    .then(resp => {
      if (resp.status === 200) {
        status = 1

        return resp.json()
      } else {
        error = {
          code: resp.status,
          message: resp.statusText
        }
        return null
      }
    })
    .then(data => {
      if (data.length > 0) {
        result = _.orderBy(data.map((value, index) => personMapping(value, index)), ['firstName', 'surName'], ['asc', 'asc'])

        itemsCount = result.length
      }
    })
    .catch(fetchError => {
      error = fetchError
    });

  return {
    status,
    result,
    itemsCount,
    error
  }
}

async function getPersonEdu(staffId) {
  let result = [], itemsCount = 0, status = 0, error = null
  const uri = SOURCE_URI + "/person_edu"

  await fetch(uri, {
    method: "POST",
    headers: {
      "Content-type": "application/json",
      "x-api-key": X_API_KEY
    },
    body: JSON.stringify({ id: staffId })
  })
    .then(resp => {
      if (resp.status === 200) {
        status = 1

        return resp.json()
      } else {
        error = {
          code: resp.status,
          message: resp.statusText
        }
        return null
      }
    })
    .then(data => {
      if (data.length > 0) {
        result = data.map((value, index) => educationMapping(value, index))
        itemsCount = data.length
      }
    })
    .catch(fetchError => {
      error = fetchError
    });

  return {
    status,
    result,
    itemsCount,
    error
  }
}

async function getResearch(staffId) {
  let result = [], itemsCount = 0, status = 0, error = null

  if (staffId) {
    const uri = "https://apis.eng.psu.ac.th/personnel/vhrmis/v1/awpublish/?mtype_id=1&is_show=1&find=" + staffId

    await fetch(uri, {
      method: "GET",
      headers: {
        'Content-Type': 'application/json',
        'X-DreamFactory-API-Key': X_DREAM_FACTORY_API_KEY
      },
    })
      .then(resp => {
        if (resp.status === 200) {
          status = 1
          return resp.json()
        } else {
          error = {
            code: resp.status,
            message: resp.statusText
          }
          return null
        }
      })
      .then(data => {
        if (data.resource.length > 0) {
          result = data.resource.map((value, index) => achievementMapping(value, index))
          itemsCount = data.resource.length
        }
      })
      .catch(fetchError => {
        error = fetchError
      });
  }

  return {
    status,
    result,
    itemsCount,
    error
  }
}

async function getJournal(staffId) {
  let result = [], itemsCount = 0, status = 0, error = null

  if (staffId) {
    const uri = "https://apis.eng.psu.ac.th/personnel/vhrmis/v1/awpublish/?mtype_id=2,3&is_show=1&find=" + staffId

    await fetch(uri, {
      method: "GET",
      headers: {
        'Content-Type': 'application/json',
        'X-DreamFactory-API-Key': X_DREAM_FACTORY_API_KEY
      },
    })
      .then(resp => {
        if (resp.status === 200) {
          status = 1
          return resp.json()
        } else {
          error = {
            code: resp.status,
            message: resp.statusText
          }
          return null
        }
      })
      .then(data => {
        if (data.resource.length > 0) {
          result = data.resource.map((value, index) => achievementMapping(value, index))
          itemsCount = data.resource.length
        }
      })
      .catch(fetchError => {
        error = fetchError
      });
  }

  return {
    status,
    result,
    itemsCount,
    error
  }
}

async function getAward(staffId) {
  let result = [], itemsCount = 0, status = 0, error = null
  const uri = SOURCE_URI + "/person_award"

  await fetch(uri, {
    method: "POST",
    headers: {
      "Content-type": "application/json",
      "x-api-key": X_API_KEY
    },
    body: JSON.stringify({ id: staffId })
  })
    .then(resp => {
      if (resp.status === 200) {
        status = 1

        return resp.json()
      } else {
        error = {
          code: resp.status,
          message: resp.statusText
        }
        return null
      }
    })
    .then(data => {
      if (data.length > 0) {
        result = data.map((value, index) => awardMapping(value, index))
        itemsCount = data.length
      }
    })
    .catch(fetchError => {
      error = fetchError
    });

  return {
    status,
    result,
    itemsCount,
    error
  }
}

async function getCV(staffId) {
  let result = null, status = 0, error = null

  if (staffId) {
    const uri = CV_URI + `?find=${staffId}&is_publish=true`

    await fetch(uri, {
      method: "GET",
      headers: {
        "Content-type": "application/json",
        'X-DreamFactory-API-Key': X_DREAM_FACTORY_API_KEY
      }
    })
      .then(resp => {
        if (resp.status === 200) {
          status = 1

          return resp.json()
        } else {
          error = {
            code: resp.status,
            message: resp.statusText
          }
          return null
        }
      })
      .then(data => {        
        if (data.resource.length > 0) {
          result = data.resource[0]
        }
      })
      .catch(fetchError => {
        error = fetchError
      });
  }

  return {
    status,
    result,
    error
  }
}

export {
  getPerson,
  getPersonByUniStaffID,
  getPersonEdu,
  getResearch,
  getJournal,
  getAward,
  getCV
}